__turbopack_context__.v({
  "centerBackground": "technologies-showcase-module__VAhxNa__centerBackground",
  "centerCircle": "technologies-showcase-module__VAhxNa__centerCircle",
  "centerContent": "technologies-showcase-module__VAhxNa__centerContent",
  "centerItem": "technologies-showcase-module__VAhxNa__centerItem",
  "centerLabel": "technologies-showcase-module__VAhxNa__centerLabel",
  "description": "technologies-showcase-module__VAhxNa__description",
  "expanded": "technologies-showcase-module__VAhxNa__expanded",
  "headerRow": "technologies-showcase-module__VAhxNa__headerRow",
  "headerTitle": "technologies-showcase-module__VAhxNa__headerTitle",
  "leftHalf": "technologies-showcase-module__VAhxNa__leftHalf",
  "rightHalf": "technologies-showcase-module__VAhxNa__rightHalf",
  "scrollContainer": "technologies-showcase-module__VAhxNa__scrollContainer",
  "techCircle": "technologies-showcase-module__VAhxNa__techCircle",
  "techContent": "technologies-showcase-module__VAhxNa__techContent",
  "techItem": "technologies-showcase-module__VAhxNa__techItem",
  "techLogo": "technologies-showcase-module__VAhxNa__techLogo",
  "techLogoImg": "technologies-showcase-module__VAhxNa__techLogoImg",
  "techLogoMark": "technologies-showcase-module__VAhxNa__techLogoMark",
  "techLogoWidest": "technologies-showcase-module__VAhxNa__techLogoWidest",
  "techName": "technologies-showcase-module__VAhxNa__techName",
  "techTooltip": "technologies-showcase-module__VAhxNa__techTooltip",
  "wrapper": "technologies-showcase-module__VAhxNa__wrapper",
});
